function transformBaseExtraDisplay(base: string, baseDisplay: string, extraCoin?: string) {
    return extraCoin === base ? baseDisplay : extraCoin || "";
}

export default transformBaseExtraDisplay;
